import React, { useState } from 'react';

const ReadMore = ({ text, minLength, charLength, ...props }) => {
    const [isReadMore, setIsReadMore] = useState(false);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text">
            {isReadMore ?   text && text : text && text.slice(0, minLength)}
            <span
                onClick={toggleReadMore}
                className={
                    !isReadMore
                        ? "cursor text-danger f10-500"
                        : "read-or-hide cursor f10-500"
                }
                style={{ color: isReadMore ? "#8a2be2" : "" }}
            >
                {charLength > minLength ? (isReadMore  ? "show less"    : "...read more")    : ""}
                
            </span>
        </p>
    );
};

export default ReadMore;